import { Injectable, inject } from '@angular/core';
import { ToastDataV2, ToastV2Service } from '@schenck/rotec-components';
import { MachineTaskService } from './machine-task.service';
import { ToolingTaskService } from './tooling-task.service';
import { TaskBaseService, TaskEvent } from './task-base.service';

@Injectable()
export class TaskToastService {
  constructor() {
    const toastService = inject(ToastV2Service);
    const machineTaskService = inject(MachineTaskService);
    const toolingTaskService = inject(ToolingTaskService);

    this.setupTaskListener(machineTaskService, toastService);
    this.setupTaskListener(toolingTaskService, toastService);
  }

  private setupTaskListener(taskService: TaskBaseService<any>, toastService: ToastV2Service) {
    // No unsubscribe needed because this service lives the whole browsersession.
    taskService.taskChange$.subscribe((event) => {
      toastService.open(<ToastDataV2>{
        type: 'success',
        title: this.getBannerHeaderText(event) as 'Success',
        text: 'The list was updated',
      });
    });
  }

  private getBannerHeaderText(event: TaskEvent) {
    switch (event) {
      case TaskEvent.Deleted:
        return 'Task(s) deleted';
      case TaskEvent.Done:
        return 'Task done';
      case TaskEvent.Shifted:
        return 'Task shifted';
      case TaskEvent.Skipped:
        return 'Task skipped';
      case TaskEvent.Updated:
        return 'Task updated';
      case TaskEvent.Created:
        return 'Task(s) created';
      case TaskEvent.Reactivated:
        return 'Task reactivated';
      default:
        return '';
    }
  }
}
